(function(){
  var t=document.querySelector('.menu-toggle'), d=document.getElementById('mobile-drawer');
  if(t&&d){t.addEventListener('click',function(){
    var open=d.classList.toggle('open'); t.setAttribute('aria-expanded',String(open));
  });}

  document.querySelectorAll('.qty').forEach(function(q){
    var input=q.querySelector('input');
    q.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click',function(){
        var v=parseInt(input.value||'1',10);
        v = b.dataset.step==='up' ? v+1 : Math.max(1,v-1);
        input.value=v;
      });
    });
  });

  document.querySelectorAll('.thumbs button').forEach(function(b){
    b.addEventListener('click',function(){
      var main=document.querySelector('.gallery .main img');
      if(main&&b.dataset.src){main.src=b.dataset.src; main.srcset='';}
      b.closest('.thumbs').querySelectorAll('button').forEach(function(x){x.setAttribute('aria-current','false');});
      b.setAttribute('aria-current','true');
    });
  });
})();
